import { DatePipe } from '@angular/common';

export class DateUtility {

    /**
     * Returns true if a timestamp has passed.
     * @param timeStamp  The timestamp to compare to now
     */
    public static expired(timeStamp: number): boolean {
        return timeStamp < Math.round((new Date()).getTime() / 1000);
    }

    /**
     * Returns a string formatted as a date input
     * @param target  The date to format
     */
     public static dateInputValue(target: Date): string | undefined {
        if (!target) { return undefined; }
        return new Date(target).toJSON().slice(0, 10);
    }

    /**
     * Returns a string formatted as a yyyy-MM-dd string
     * @param target The date to format
     */
     public static toInput(target: Date): string | null {
        const datePipe: DatePipe = new DatePipe('en-US');
        return datePipe.transform(new Date(target), 'yyyy-MM-dd');
    }

    /**
     * Returns a Date, 30 days from now
     */
     public static get30DaysAgo(): Date {
        const returnValue: Date = new Date();
        returnValue.setDate(returnValue.getDate() - 30);
        return returnValue;
    }

    /**
     * Returns a Date object set to the first day of the current month
     * So if today is 15th Jan 1900, this will return 1st Jan 1900
     */
     public static firstOfMonth(): Date {
        const now: Date = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1, 1, 0, 0, 0);
    }

    /**
     * Returns a Date object set to the first day of the previous month
     * So if today is 15th Feb 1900, this will return 1st Jan 1900
     */
     public static firstOfPreviousMonth(): Date {
        const subjectDate: Date = DateUtility.firstOfMonth();
        subjectDate.setDate(subjectDate.getDate() - 1);
        return new Date(subjectDate.getFullYear(), subjectDate.getMonth(), 1, 1, 0, 0, 0);
    }

    /**
     * Returns a Date object set to the first day of the current year
     * So if today is 31st Dec 1900, this will return 1st Jan 1900
     */
     public static firstOfYear(): Date {
        return new Date(new Date().getFullYear(), 1, 1, 0, 0, 0, 0);
    }
}